import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundWrapper from '../../../components/wrapper';
import StepIndicator from '../../../components/indicator';
import { Footer } from '../../../components/layouts/footer';
import { MainHeader } from '../../../components/layouts/navbar';
import InterestSelector from '../../../components/interest-selector';
import Card from '../../../components/card';

const UserInterest: React.FC = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate('/verify/bvn');
    };

    const handleSkip = () => {
        navigate('/');
    };

    return (
        <BackgroundWrapper>
            <MainHeader />
            <div className="min-h-screen pt-32 md:pt-[146px] max-w-7xl mx-auto lg:px-[120px] px-[30px]">
                <div className="mb-6">
                    <h1 className="text-2xl md:text-[36px] font-bold text-gray-900 mb-2">
                        Welcome to VouchLinks 👋
                    </h1>
                    <p className="text-gray-600 text-[18px]">
                        Complete the final steps to unlock reward withdrawals and personalise your VouchLinks experience.
                    </p>
                    <StepIndicator currentStep={3} totalSteps={3} />
                </div>

                <div className="mx-auto grid md:grid-cols-2 gap-8">
                    <Card>
                        <InterestSelector
                            onSuccess={handleSuccess}
                            onSkip={handleSkip}
                            variant="page"
                        />
                    </Card>


                    {/* Hero Image */}
                    <div className="hidden w-full md:block">
                        <img src="/signupCover.png" alt="cover" />
                    </div>
                </div>
            </div>
            <Footer />
        </BackgroundWrapper>
    );
};

export default UserInterest;